var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.523 28.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 14.261,
    y1: 669.257,
    x2: 14.261,
    y2: 667.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#370099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#5e45e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    "data-name": "search icon"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.261,
    cy: 14.261,
    r: 14.261
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.127,20.487l-4.279-4.278a5.52,5.52,0,1,0-.642.641l4.28,4.278a.453.453,0,0,0,.641,0A.453.453,0,0,0,21.127,20.487ZM8.17,12.708a4.54,4.54,0,1,1,4.54,4.541A4.546,4.546,0,0,1,8.17,12.708Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0074351f0fc1d9bf9262ee7c88b61327.svg";
export { ForwardRef as ReactComponent };